import LandingPageLayout from 'components/LandingPageLayout';
import React from 'react';
import ReservationForm from 'components/LandingPageReservationForm';
import Benefits from 'components/LandingPageBenefits';
import AboutUsSlider from 'components/LandingPageAboutUsSlider';
import TitleSectionOne from 'components/LandingPageTitleSection/TitleSectionOne';
import Professionals from 'components/LandingPageProfessionals';
import Head from 'next/head';
const RoomsForRentInToronto = () => {
  return (
    <div>
      <Head>
        <meta charset="utf-8" />
        <meta http-equiv="X-UA-Compatible" content="IE=edge" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <title>Entire units and Shared accommodation</title>
        <meta
          name="description"
          content="Rent and communicate with your landlord conveniently using soulrooms. Whether you’re moving with friends or flying solo, we’ve got you covered."
        />
        <meta name="author" content="SoulRooms" />
        <meta property="og:url" content="https://soulrooms.com/rooms-for-rent-in-toronto" />
        <meta property="og:site_name" content="SoulRooms" />
        <meta property="og:title" content="Entire units and Shared accommodation" />
        <meta
          property="og:description"
          content="Rent and communicate with your landlord conveniently using soulrooms. Whether you’re moving with friends or flying solo, we’ve got you covered."
        />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta property="og:locale" content="en_US" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@soulroomsTO" />
        <meta name="twitter:title" content="SoulRooms" />
        <meta
          name="twitter:description"
          content="Rent and communicate with your landlord conveniently using soulrooms. Whether you’re moving with friends or flying solo, we’ve got you covered."
        />
        <meta name="twitter:image" content="https://img1.wsimg.com/isteam/videos/naBxa52" />
        <meta name="twitter:image:alt" content="SoulRooms" />
        <meta name="theme-color" content="#FCBD00" />

        <link rel="canonical" href="https://www.soulrooms.com/rooms-for-rent-in-toronto" />
      </Head>
      <LandingPageLayout>
        <Professionals
          spacing={true}
          img={
            <img
              loading="lazy"
              src="/static/images/landingPages/roomforrent.png"
              width="100%"
              alt="pic"
              className="img img-fluid"
            />
          }
          title={'ROOMS FOR RENT'}
          description={
            <p
              className="    responsiveText pt-lg-4 pt-md-3 pt-4 pb-2   "
              style={{ fontFamily: 'Josefin Sans', color: '#5E5E5E' }}>
              Cozy, for those on a budget. En-suites for those who like their privacy and space. Regular for everyone in
              between. Check out a variety of properties listed by landlords, it's time you came home to SoulRooms.
            </p>
          }
          tagLine="Renting rooms made easy @ SoulRooms"
          btnHref="#JotFormIFrame-91797058303261"
          btnTitle="See available options"
        />
        {/* BENEFITS  */}
        <Benefits
          spacing={true}
          heading="BENEFITS FOR USING OUR PLATFORM AS A RENTER"
          card1Title="Single Renter Profile"
          card2title="Seamless Online Booking"
          card3Title="Online Community"
          card4Title="Integrated Screening"
          card5Title="Renter's Portal"
          card6Title="No Scams"
        />

        {/* RESERVATION FORM  */}
        <ReservationForm spacing={true} heading="FILL IN YOUR REQUIREMENTS & SEE AVAILABLE OPTIONS">
          <iframe
            id="JotFormIFrame-91797058303261"
            title="Find a SoulRoom"
            onLoad={() => {
              window.parent.scrollTo(0, 0);
            }}
            allowTransparency="true"
            allowFullScreen="true"
            allow="geolocation; microphone; camera"
            src="https://form.jotform.com/91797058303261"
            frameBorder="0"
            style={{ minWidth: '100%', height: '640px', border: 'none' }}
            scrolling="no"></iframe>
        </ReservationForm>

        {/* ABOUT US SLIDER  */}
        <AboutUsSlider heading="Featured in:" bg={'black'} />
        <TitleSectionOne
          title="HAVE QUESTIONS?"
          btnTxt="Chat with us"
          bg="white"
          hrefExt="https://www.messenger.com/login.php?next=https%3A%2F%2Fwww.messenger.
          com%2Ft%2F404951336769102%2F%3Fmessaging_source%3Dsource%253Apages%253Amessage_shortlink"
        />
      </LandingPageLayout>
    </div>
  );
};

export default RoomsForRentInToronto;
